import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=1a794e92&scoped=true&"
import script from "./Counter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Counter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Counter.vue?vue&type=style&index=0&id=1a794e92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a794e92",
  null
  
)

export default component.exports